import React from 'react';

interface IconProps {
  width?: string;
  height?: string;
  hover?: boolean;
  fill?: string;
}

export const PatientPOrangeIcon: React.FC<IconProps> = ({
  width = '24px',
  height = '24px',
  fill = '#FFFFFF',
  hover
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='22' height='23' viewBox='0 0 22 23' fill='none'>
      <path
        d='M10 15.2765V17.7235C10 18.331 10.4925 18.8235 11.1 18.8235H13.1765V20.9C13.1765 21.5075 13.669 22 14.2765 22H16.7235C17.331 22 17.8235 21.5075 17.8235 20.9V18.8235H19.9C20.5075 18.8235 21 18.331 21 17.7235V15.2765C21 14.669 20.5075 14.1765 19.9 14.1765H17.8235V12.1C17.8235 11.4925 17.331 11 16.7235 11H14.2765C13.669 11 13.1765 11.4925 13.1765 12.1V14.1765H11.1C10.4925 14.1765 10 14.669 10 15.2765Z'
        stroke='#F5981E'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path d='M1 19V16C1 13.7909 2.79086 12 5 12H10' stroke='#F5981E' strokeWidth='2' strokeLinecap='round' />
      <circle cx='8' cy='5' r='4' stroke='#F5981E' strokeWidth='2' />
    </svg>
  );
};
